<template>
  <div class="text-center d-grid">
    <button type="button" class="btn btn-light btn-small btn-with-break-lines" @click="buttonClicked">
      {{ i18n.t('events.show.update_to_not_attending') }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { NOT_ATTENDING } from './attending-statuses'

export default {
  computed: {
    ...mapState(['eventStatus'])
  },

  methods: {
    buttonClicked() {
      if (this.eventStatus.full) {
        this.$store.commit('showConfirmNotAttendingModal')
      } else {
        this.$store.dispatch('updateAttendee', { attendingStatus: NOT_ATTENDING })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-light {
  text-transform: unset;
}
</style>
